import type { PainLogConfig, WidgetConfig } from "@/lib/schema";
import { getWidgetModule } from "@/widgets/registry";
import type { DayWidgetModule } from "@/widgets/types";
import { DayView } from "./DayView";
import { SettingsEditor } from "./SettingsEditor";
import { maxScoreWeek, scoreDay, scoreWeek } from "./scoring";
import { validate } from "./validate";

function defaults(existing: WidgetConfig[]): PainLogConfig {
  const dayWidgets = existing.filter(
    (w) => getWidgetModule(w.kind)?.scope === "day",
  );
  const maxRow = dayWidgets.reduce((m, w) => Math.max(m, w.row), -1);
  return {
    id: crypto.randomUUID(),
    kind: "pain-log",
    label: "Magesmerter",
    row: maxRow + 1,
    column: 0,
    enabled: true,
    points: 1,
    weekGoal: 7,
  };
}

// No describeWeekData: the Pain entries live globally and survive the widget
// (docs/adr/0028). The week holds only the scoring mirror, which the widget
// rebuilds from the entries wherever an instance shows the day again.
export const painLog: DayWidgetModule<PainLogConfig> = {
  kind: "pain-log",
  label: "Magesmerter",
  scope: "day",
  scoring: "points",
  defaults,
  validate,
  SettingsEditor,
  DayView,
  scoreDay,
  scoreWeek,
  maxScoreWeek,
};
